export class 取込ファイル明細型 {
  public 取込行番号: number;
  public 移動日: Date;
  public 商品名: string;
  public 部署名: string;
  public エラー内容: string;

  constructor(取込行番号: number, 移動日: Date, 商品名: string, 部署名: string, エラー内容: string) {
    this.取込行番号 = 取込行番号;
    this.移動日 = 移動日;
    this.商品名 = 商品名;
    this.部署名 = 部署名;
    this.エラー内容 = エラー内容;
  }
}
